export const MuiDialogNode = {
  styleOverrides: {
    root: {
      "& .MuiPaper-root": {
        borderRadius: 16,
      },
    },
  },
};
